var $ = require('jquery');

function changeQuantity(row, type, e) {
    var orderId = row.data('orderid');
    var changeValue = type == 'decrease' ? -1 : 1;
    var quantityDom = row.find('.cart-product-quantity-value');
    var beforeQuantity = parseInt(row.find('.cart-product-quantity-value').text());
    var afterQuantity = beforeQuantity + changeValue;
    if (afterQuantity < 0) {
        afterQuantity = 0;
    }

    var zeroedQuantity = afterQuantity == 0;

    if (zeroedQuantity) {
        let buttons = {};
        buttons[Translator.trans('Delete')] = function(win) {
            document.location.href = RoutingS1.generate('cartItem', {
                id: orderId,
                do: 'delete'
            });
        };
        buttons[Translator.trans('Cancel')] = function(win) {
            win.closeModal();
        };
        $.modal({
            content: Translator.trans('Do you want to delete order?'),
            title: Translator.trans('Delete order'),
            maxWidth: 700,
            maxHeight: 450,
            resizable: false,
            buttons: buttons
        });
    }
    else {
        quantityDom.text(afterQuantity);
        clearTimeout(checkCalculationTimeout);
        loadingCartItemPrice(orderId, true);
        checkCalculationTimeout = setTimeout(function () {
            applyQuantityChange(orderId, afterQuantity);
        }, 500);
    }
}

function applyQuantityChange(orderId, quantity) {
    $.ajax({
        method: 'POST',
        url: RoutingS1.generate('orderApplyQuantityChange'),
        data: {
            orderId: orderId,
            quantity: quantity,
        },
        dataType: 'json',
        success: function(response) {
            var row = $('#order-item-' + orderId);
            var basketItem = findBasketItemById(orderId, response.summary.basket);
            var newPriceNet = basketItem.total_amount;
            var newPriceGross = basketItem.total_amount_gross;
            loadingCartItemPrice(orderId, false);
            $('.depends-on-restrictions').toggleClass('hidden', !response.basketRestrictionPassed);
            $('#products-restrictions').toggleClass('hidden', response.basketRestrictionPassed);
            var priceNetFull = row.find('.price-net-value').text();
            var priceNetSplited = priceNetFull.split(' ');
            row.find('.price-net-value').text(newPriceNet + ' ' + priceNetSplited[1]);

            var priceGrossFull = row.find('.price-gross-value').text();
            var priceGrossSplited = priceGrossFull.split(' ');
            row.find('.price-gross-value').text(newPriceGross + ' ' + priceGrossSplited[1]);
        },
        error: function(response) {
            console.log(response);
        }
    });
}

function loadingCartItemPrice(orderId, loading) {
    var row = $('#order-item-' + orderId);
    row.find('.cart-price-pos').toggle(!loading);
    row.find('.cart-item-price-loader').toggleClass('hidden', !loading);
}

function findBasketItemById(id, basket) {
    for (var i in basket.items) {
        var item = basket.items[i];
        if(item.id == id) {
            return item;
        }
    }
    return null;
}

$(document).ready(function() {
    var checkCalculationTimeout;
    $('.increase-quantity').click(function(e){
        var row = $(this).parents('tr');
        changeQuantity(row, 'increase', e);
    });

    $('.decrease-quantity').click(function(e) {
        var row = $(this).parents('tr');
        changeQuantity(row, 'decrease', e);
    });

    $('#cart-save-button').click(function() {

    });
});
